import * as React from "react";
import TimeList from "./TimeList";
import EditTime from "./EditTime";
import EventType from "components/Setting/EventType";
import { addTimeType } from "services/timeTypeService";

const TimeTypes = (props) => {
  return (
    <EventType
      open={props.open}
      close={props.close}
      apiAddFunc={addTimeType}
      buttonLabel="Time Types"
      listComponent={TimeList}
      editFormComponent={EditTime}
      component="timeTypes"
    />
  );
};

export default TimeTypes;
